import { render, staticRenderFns } from "./VersionHistoryDialog.vue?vue&type=template&id=42e7e6a0"
import script from "./VersionHistoryDialog.vue?vue&type=script&lang=js"
export * from "./VersionHistoryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports